import React, { useState, useEffect } from 'react'
import CTAInterestSuggestions from 'srcReact/FeedPage/components/CTAInterestSuggestions'
import CTANewGroup from 'srcReact/FeedPage/components/CTANewGroup'
import CTANewMembers from 'srcReact/FeedPage/components/CTANewMembers'
import { appConstantSettings } from 'srcReact/appConstantSettings'

function CTARender({ availableCTAs, ctas, currentIndex, displayAllCTA }) {
  const [type, setType] = useState('')
  useEffect(() => {
    if (ctas && currentIndex < appConstantSettings.FEED_COUNT_FOR_CTA * 3) {
      if (displayAllCTA) {
        setType('all')
      } else {
        //availableCTAs.length -> Ensures that there are available CTAs to display.
        //(currentIndex + 1) % 3 -> check if current index is multiple of 3
        if (availableCTAs.length > 0 && (currentIndex + 1) % appConstantSettings.FEED_COUNT_FOR_CTA === 0) {
          //(currentIndex + 1) / 3 -> This division determines how many times "3" fits into the incremented index.
          // It's essentially trying to figure out how many groups of "3" items are before the current index.
          //e.g. appConstantSettings.FEED_COUNT_FOR_CTA is 3, and currentIndex is 5.
          //The calculation would be: (5 + 1) / 3 equals 2.
          //Subtracting 1: 2 - 1 equals 1.
          //So, for the given values, widgetIndex would be 1. This would mean that at index 5 (1-based index), it's the second "group" of "3" items and the zero-based index is 1.
          const widgetIndex = (currentIndex + 1) / appConstantSettings.FEED_COUNT_FOR_CTA - 1
          //check if widgetIndex is within the bounds of the availableCTAs array,
          if (widgetIndex < availableCTAs.length) {
            setType(availableCTAs[widgetIndex])
          }
        }
      }
    }
  }, [])

  return type === 'all' ? (
    <React.Fragment>
      {ctas.new_members?.total_new_member_count > 0 && <CTANewMembers />}
      {ctas.interest_suggestions?.length > 0 && <CTAInterestSuggestions />}
      {ctas.a_new_group?.length > 0 && <CTANewGroup />}
    </React.Fragment>
  ) : type === 'new_members' ? (
    <CTANewMembers />
  ) : type === 'interest_suggestions' ? (
    <CTAInterestSuggestions />
  ) : type === 'a_new_group' ? (
    <CTANewGroup />
  ) : null
}

export default CTARender
